// Copyright (c) 2017 TrainHeroic LLC
// Actions for Designer Table of Contents View

export default {
    UI_HOVER_DAY: 'designer-toc-ui-hover-day'
};



// WEBPACK FOOTER //
// ./src/state/reducer/designerTOC/actions.js